export const USAGE_PAGE_SIZE = 5

export function getPaginatedItems<T>(items: T[], currentPage: number, pageSize = USAGE_PAGE_SIZE): T[] {
  const start = currentPage * pageSize
  return items.slice(start, start + pageSize)
}

export function shouldShowPagination(totalItems: number, pageSize = USAGE_PAGE_SIZE): boolean {
  return totalItems > pageSize
}
